import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import Header from "./components/Header";
import WhatsAppFab from "./components/WhatsAppFab";
import TopBar from "./components/TopBar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Evolutivos from "./pages/Evolutivos";
import Robux from "./pages/Robux";
import Recompensas from "./pages/Recompensas";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import PaymentResult from "./pages/PaymentResult";
import ErrorBoundary from "./components/ErrorBoundary";
import { Toaster } from "sonner";
import MaintenanceGate from "./components/MaintenanceGate";
import { HalloweenBackdrop } from "./components/Halloween";
import WhatsAppGroupPopup from "./components/WhatsAppGroupPopup";
import Revendedores from "./pages/Revendedores";

function AppShell() {
  const location = useLocation();
  // Detect OAuth callback synchronously to avoid race conditions with ProtectedRoute
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <MaintenanceGate>
      <HalloweenBackdrop />
      <WhatsAppGroupPopup />
      <TopBar />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/evolutivos" element={<Evolutivos />} />
        <Route path="/robux" element={<Robux />} />
        <Route path="/recompensas" element={<Recompensas />} />
        <Route path="/revendedores" element={<Revendedores />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/payment/result" element={<PaymentResult />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
      <WhatsAppFab />
    </MaintenanceGate>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
    <Toaster theme="dark" position="bottom-center" richColors />
    <BrowserRouter>
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    </BrowserRouter>
    </ErrorBoundary>
  );
}
